import { SearchOutlined } from '@ant-design/icons';
import { formatDate, sortStringPlus } from 'commons/helpers/utils';
import DropdownFilterSearch from 'pages/DashboardStaff/components/filters/DropdownFilter';

export const getDefaultColumns = (translate) => [
  {
    title: translate('dashboardStaff.names'),
    dataIndex: 'nombre',
    sorter: {
      compare: sortStringPlus('nombre'),
      multiple: 15
    },
    ellipsis: true,
    filter: {
      type: 'search',
      searchName: 'filterName'
    }
  },
  {
    title: translate('dashboardStaff.lastNames'),
    dataIndex: 'apellidos',
    sorter: {
      compare: sortStringPlus('apellidos'),
      multiple: 14
    },
    ellipsis: true,
    filter: {
      type: 'search',
      searchName: 'filterLastName'
    }
  },
  {
    title: translate('dashboardStaff.documentType'),
    dataIndex: 'tipodoc',
    sorter: {
      compare: sortStringPlus('tipodoc'),
      multiple: 13
    },
    ellipsis: true
  },
  {
    title: translate('dashboardStaff.id'),
    dataIndex: 'documento',
    sorter: {
      compare: sortStringPlus('documento'),
      multiple: 12
    },
    ellipsis: true,
    filter: {
      type: 'search',
      searchName: 'filterDocument'
    }
  },
  {
    title: translate('dashboardStaff.age'),
    dataIndex: 'edad',
    sorter: {
      compare: sortStringPlus('edad'),
      multiple: 11
    },
    ellipsis: true,
    filter: {
      type: 'select',
      searchName: 'filterAge',
      listName: 'listaEdad'
    }
  },
  {
    title: translate('dashboardStaff.insuranceCarrier'),
    dataIndex: 'aseguradora',
    sorter: {
      compare: sortStringPlus('aseguradora'),
      multiple: 10
    },
    ellipsis: true,
    filter: {
      type: 'select',
      searchName: 'filterInsurer',
      listName: 'listAseguradora'
    }
  },
  {
    title: translate('dashboardStaff.kidneyUnit'),
    dataIndex: 'clinica',
    sorter: {
      compare: sortStringPlus('clinica'),
      multiple: 9
    },
    ellipsis: true,
    filter: {
      type: 'select',
      searchName: 'filterInitRenal',
      listName: 'listaUnidadRenal'
    }
  },
  {
    title: translate('dashboardStaff.TFGCGSNoAdjustment'),
    dataIndex: 'tfg_cockroft_gault_sin_ajuste',
    sorter: {
      compare: sortStringPlus('tfg_cockroft_gault_sin_ajuste'),
      multiple: 8
    },
    ellipsis: true,
    filter: {
      type: 'select',
      searchName: 'filterTfgCockroftGaultSinAjuste',
      listName: 'listaTfgCockroftGaultSinAjuste'
    }
  },
  {
    title: translate('dashboardStaff.TFGCGSNoAdjustmentDate'),
    dataIndex: 'fecha_estadio',
    sorter: {
      compare: sortStringPlus('fecha_estadio'),
      multiple: 7
    },
    render: formatDate,
    ellipsis: true,
    filter: {
      type: 'select',
      searchName: 'filterDateTfgCockroftGaultSinAjuste',
      listName: 'listaFechaTfgCockroftGaultSinAjuste'
    }
  },
  {
    title: translate('dashboardStaff.stageTFGCGNoAdjustment'),
    dataIndex: 'estadio_tfg_cockroft_gault_sin_ajuste',
    sorter: {
      compare: sortStringPlus('estadio_tfg_cockroft_gault_sin_ajuste'),
      multiple: 6
    },
    ellipsis: true,
    filter: {
      type: 'select',
      searchName: 'filterEstadioTfgCockRoftGaultSinAjuste',
      listName: 'listaEstadioTfgCockroftGaultSinAjuste'
    }
  },
  {
    title: translate('dashboardStaff.TFGCEpi2009'),
    dataIndex: 'tfg_ckd_epi_2009_valor',
    sorter: {
      compare: sortStringPlus('tfg_ckd_epi_2009_valor'),
      multiple: 5
    },
    ellipsis: true,
    filter: {
      type: 'select',
      searchName: 'filterTfgCkdEpi2009',
      listName: 'listaTfgCkdEpi2009'
    }
  },
  {
    title: translate('dashboardStaff.TFGCEpi2009Date'),
    dataIndex: 'tfg_ckd_epi_2009_fecha',
    sorter: {
      compare: sortStringPlus('tfg_ckd_epi_2009_fecha'),
      multiple: 4
    },
    ellipsis: true,
    render: formatDate,
    filter: {
      type: 'select',
      searchName: 'filterDateTfgCockroftGaultSinAjuste',
      listName: 'ListaFechaTfgCkdEpi2009'
    }
  },
  {
    title: translate('dashboardStaff.stageTFGCEpi2009'),
    dataIndex: 'tfg_ckd_epi_2009_estadio',
    sorter: {
      compare: sortStringPlus('tfg_ckd_epi_2009_estadio'),
      multiple: 3
    },
    ellipsis: true,
    filter: {
      type: 'select',
      searchName: 'filterStadiumTfgCkdEpI2009',
      listName: 'listaEstadioTfgCkdEpi2009'
    }
  },
  {
    title: translate('dashboardStaff.modality'),
    dataIndex: 'modalidad',
    sorter: {
      compare: sortStringPlus('modalidad'),
      multiple: 2
    },
    ellipsis: true,
    filter: {
      type: 'select',
      searchName: 'filterModalidity',
      listName: 'listaModalidad'
    }
  },
  {
    title: translate('dashboardStaff.albuminuria'),
    dataIndex: 'clasificacion_albuminuria',
    sorter: {
      compare: sortStringPlus('clasificacion_albuminuria'),
      multiple: 1
    },
    ellipsis: true,
    filter: {
      type: 'select',
      searchName: 'filterClasificationAlbuminuria',
      listName: 'listaClasificacionAlbuminuria'
    }
  }
];

export const setBadgeVariation = (
  data,
  translate,
  bgColorsBadget = ['bg-stage-2', 'bg-baxterTale', 'bg-error', 'bg-gray-400']
) => {
  let badgeVariation = '';
  return data.map((itm) => {
    switch (itm.variacion) {
      case 'Estable':
        badgeVariation = (
          <div
            className={`text-center font-bold w-max px-4 text-white rounded-full ${bgColorsBadget[0]}`}>
            {translate('dashboardStaff.Estable')}
          </div>
        );
        break;
      case 'Mejora':
        badgeVariation = (
          <div
            className={`text-center font-bold w-max px-4 text-white rounded-full ${bgColorsBadget[1]}`}>
            {translate('dashboardStaff.Mejora')}
          </div>
        );
        break;
      case 'Empeora':
        badgeVariation = (
          <div
            className={`text-center font-bold w-max px-4 text-white rounded-full ${bgColorsBadget[2]}`}>
            {translate('dashboardStaff.Empeora')}
          </div>
        );
        break;
      case 'Sin Datos':
        badgeVariation = (
          <div
            className={`text-center font-bold w-max px-4 text-white rounded-full ${bgColorsBadget[3]}`}>
            {translate('dashboardStaff.noComparission')}
          </div>
        );
        break;
      default:
        break;
    }
    return { ...itm, badgeVariation };
  });
};

export const setBadgeVariationProteinuria = (variacion) => {
  const bgColorsBadget = [
    'bg-stage-2',
    'bg-baxterTale',
    'bg-error',
    'bg-gray-400'
  ];
  let badgeVariation = '';
  switch (variacion) {
    case 'Estable':
      badgeVariation = (
        <div
          className={`text-center font-bold w-max px-4 text-white rounded-full ${bgColorsBadget[0]}`}>
          {variacion}
        </div>
      );
      break;
    case 'Mejora':
      badgeVariation = (
        <div
          className={`text-center font-bold w-max px-4 text-white rounded-full ${bgColorsBadget[1]}`}>
          {variacion}
        </div>
      );
      break;
    case 'Empeora':
      badgeVariation = (
        <div
          className={`text-center font-bold w-max px-4 text-white rounded-full ${bgColorsBadget[2]}`}>
          {variacion}
        </div>
      );
      break;
    case 'Sin Datos':
      badgeVariation = (
        <div
          className={`text-center font-bold w-max px-4 text-white rounded-full ${bgColorsBadget[3]}`}>
          {variacion}
        </div>
      );
      break;
    default:
      break;
  }
  return badgeVariation;
};

export const translateBooleanYesNo = (value, translate) => {
  const message = value === 'SI' ? 'dashboardStaff.Yes' : 'dashboardStaff.No';
  return translate(message);
};

export const getColumnSearchProps = (dataIndex) => ({
  filterDropdown: function getDropdown({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters
  }) {
    return (
      <DropdownFilterSearch
        dataIndex={dataIndex}
        selectedKeys={selectedKeys}
        confirm={confirm}
        clearFilters={clearFilters}
        setSelectedKeys={setSelectedKeys}
      />
    );
  },
  filterIcon: function getSearchButton(filtered) {
    return (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined
        }}
      />
    );
  }
});

export const getSelectFilter = (column, data) => {
  let dataToFilter = [];
  if (column.filter && column.filter.listName && data) {
    dataToFilter = data[column.filter.listName]?.map((item) => ({
      value: item[column.dataIndex],
      text: item[column.dataIndex]
    }));
  }
  return {
    filters: dataToFilter
  };
};

export const getColumnType = (columna, dataFilter) => {
  if (columna.filter && columna.filter.type) {
    switch (columna.filter.type) {
      case 'search':
        return {
          ...columna,
          ...getColumnSearchProps(columna.title)
        };
      case 'select':
        return {
          ...columna,
          ...getSelectFilter(columna, dataFilter)
        };
      default:
        return columna;
    }
  }
  return columna;
};

export const getColumnByType = (columns, dataFilter) => {
  const cols = columns.map((columna) => {
    return getColumnType(columna, dataFilter);
  });
  return cols;
};

export const createColumns = (translate, dataFilter) => {
  const cols = getDefaultColumns(translate);
  return getColumnByType(cols, dataFilter);
};

export const getSearchApiKeys = (columns, filters) => {
  let dataToFilter = {};
  if (columns && columns.length > 0 && filters != null) {
    Object.keys(filters).forEach((filterKey) => {
      const existvalue = columns.find((item) => item?.dataIndex === filterKey)
        ?.filter?.searchName;
      if (existvalue) {
        dataToFilter = {
          ...dataToFilter,
          [existvalue]: filters[filterKey]
        };
      }
    });
  }
  return dataToFilter;
};

export const getSorterString = (sorter) => {
  const finalSorter = [];
  if (sorter && sorter.length > 0) {
    sorter.forEach((attr) => {
      if (attr && attr.column && attr.column.dataIndex && attr.order) {
        finalSorter.push(
          `${attr.column.dataIndex} ${attr.order === 'ascend' ? 'asc' : 'desc'}`
        );
      }
    });
  } else if (
    sorter &&
    sorter.column &&
    sorter.column.dataIndex &&
    sorter.order
  ) {
    finalSorter.push(
      `${sorter.column.dataIndex} ${sorter.order === 'ascend' ? 'asc' : 'desc'}`
    );
  }

  return {
    campoOrdernamiento: finalSorter.length > 0 ? finalSorter : null
  };
};

export const PAGE_LIMIT = 10;
